document.addEventListener('DOMContentLoaded', function() {
    // Get the available pincodes from Shopify settings
    const availableZips = document.getElementById('deliver__zipcode').value;
    const availablePincodes = availableZips.split(",").map(item => item.trim());
    
    const pincodeInput = document.getElementById('deliver_zipcode');
    const verifyButton = document.querySelector('.deliver_button');
    const pincodeContainer = document.querySelector('.pincode--pdp');

    // Create message element if it doesn't exist 
    let messageElement = pincodeContainer.querySelector('.pincode-message');
    if (!messageElement) {
        messageElement = document.createElement('div');
        messageElement.className = 'pincode-message';
        messageElement.style.display = 'none';
        pincodeContainer.appendChild(messageElement);
    }

    // Format input as user types (for Indian pincodes - 6 digits)
    pincodeInput.addEventListener('input', function(e) {
        let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
        
        // Limit to 6 digits for Indian pincodes
        if (value.length > 6) {
        value = value.substring(0, 6);
        }
        
        e.target.value = value;
        
        // Hide message when user starts typing
        hideMessage();
    });

    // Handle verify button click
    verifyButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        const enteredPincode = pincodeInput.value.trim();
        
        // Validate input
        if (!enteredPincode) {
        showMessage('Please enter a pincode', 'error');
        return;
        }
        
        if (enteredPincode.length !== 6) {
        showMessage('Please enter a valid 6-digit pincode', 'error');
        return;
        }
        
        // Show loading state
        showLoading();
        
        // Simulate API delay for better UX
        setTimeout(() => {
        verifyPincode(enteredPincode);
        }, 500);
    });

    // Allow Enter key to submit
    pincodeInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
        e.preventDefault();
        verifyButton.click();
        }
    });

    function verifyPincode(pincode) {
        // Reset loading state
        resetButton();
        
        // Check if pincode exists in available list
        const isAvailable = availablePincodes.some(availableCode => 
        availableCode === pincode
        );
        
        if (isAvailable) {
        showMessage('✅ Delivery available in your area!', 'success');
        
        // Store pincode in cart attributes for checkout
        storePincodeInCart(pincode);
        
        // Optional: Trigger other actions
        onPincodeVerified(pincode);
        
        } else {
        showMessage('❌ Sorry, we don\'t deliver to this pincode yet.', 'error');
        
        }
    }

    function showLoading() {
        verifyButton.disabled = true;
        verifyButton.innerHTML = 'Checking...';
        verifyButton.style.opacity = '0.7';
    }

    function resetButton() {
        verifyButton.disabled = false;
        verifyButton.innerHTML = 'Verify ✓';
        verifyButton.style.opacity = '1';
    }

    function showMessage(text, type) {
        messageElement.textContent = text;
        messageElement.className = `pincode-message ${type}`;
        messageElement.style.display = 'block';
        
        // Auto-hide success messages after 5 seconds
        if (type === 'success') {
        setTimeout(() => {
            hideMessage();
        }, 5000);
        }
    }

    function hideMessage() {
        if (messageElement) {
        messageElement.style.display = 'none';
        }
    }

    function storePincodeInCart(pincode) {
        // Store pincode in Shopify cart attributes
        fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            attributes: {
            'delivery_pincode': pincode,
            'pincode_verified': 'true',
            'pincode_verified_at': new Date().toISOString()
            }
        })
        })
        .then(response => response.json())
        .then(data => {
        console.log('Pincode stored in cart:', data);
        })
        .catch(error => {
        console.error('Error storing pincode:', error);
        });

        // Also store in localStorage for persistence
        localStorage.setItem('verified_pincode', pincode);
        localStorage.setItem('pincode_verified_at', Date.now());
    }

    function onPincodeVerified(pincode) {
        // Trigger custom events or actions after successful verification
        
        // Example: Enable express checkout
        enableExpressCheckout();
        
        // Example: Show pincode-specific offers
        showLocalOffers(pincode);
        
        // Dispatch custom event for other scripts to listen
        document.dispatchEvent(new CustomEvent('pincodeVerified', {
        detail: { pincode: pincode }
        }));
    }

    function enableExpressCheckout() {
        // Example: Enable buy now button or express checkout
        const expressBtn = document.querySelector('.express-checkout');
        if (expressBtn) {
        expressBtn.style.display = 'block';
        expressBtn.disabled = false;
        }
    }

    function showLocalOffers(pincode) {
        // Example: Show pincode-specific promotions
        console.log(`Loading offers for pincode: ${pincode}`);
    }

    // Auto-populate if user has previously verified pincode
    function loadSavedPincode() {
        const savedPincode = localStorage.getItem('verified_pincode');
        const savedTime = localStorage.getItem('pincode_verified_at');
        
        // Check if pincode was verified in last 24 hours
        if (savedPincode && savedTime) {
        const hoursSinceVerification = (Date.now() - parseInt(savedTime)) / (1000 * 60 * 60);
        
        if (hoursSinceVerification < 24) {
            pincodeInput.value = savedPincode;
            showMessage('✅ Previously verified pincode loaded', 'success');
        }
        }
    }

    // Load saved pincode on page load
    loadSavedPincode();
    });

    // CSS styles for the message
    const style = document.createElement('style');
    style.textContent = `
    .pincode-message {
        margin-top: 10px;
        padding: 10px 15px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
    }

    .pincode-message.success {
        background-color: #d4edda;
        color: #155724;
        border: 1px solid #c3e6cb;
    }

    .pincode-message.error {
        background-color: #f8d7da;
        color: #721c24;
        border: 1px solid #f5c6cb;
    }

    .pincode-alternatives {
        margin-top: 10px;
        padding: 12px;
        background: #f8f9fa;
        border-radius: 6px;
        border-left: 3px solid #007bff;
    }

    .deliver_button:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
    `;
document.head.appendChild(style);